import React from "react";
import { Form, Row, Col, Select, Button, message, Icon } from "antd";
import img from "./../../../assets/img/freepik  Plant  inject 2.png";
import MiCompAPI from "../../../util/api";
import moment from "moment";
const { Option } = Select;
class Plan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isValueExists: false,
      planEditable: false,
      title: this.props.plan_type ? "Update Plan" : "New Plan Requirement",
      carrier: [],
      plan: [],
      name: [],         
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {      
      if (!err) {
        this.api.invoke(
          "savePlanchangeRequest",
          "post",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 3);
                this.props.closeDrawerHandler(true);
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            } else {
              message.destroy();
              message.error(data.statusMessage, 3, 2.5);
            }
          },
          {
            ...values,
            requestDate: moment(this.props.endata.dis_enrolment_date)
              .add(1, "days")
              .format("MM/DD/yyyy"),
          }
        );
      }
   });
  };
  componentDidMount = () => {
    this.GetAllClients();    
  };
  GetAllClients = () => {
    this.api.invoke(
      "GetBrokerwiseMemberCarriers/" + this.props.endata.brokerUserId,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              carrier: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }; 
  GetPlansbyClientId = (clientId, plan_Id) => {
    this.api.invoke(
      "GetPlansbyClientsId/" + clientId + "/" + plan_Id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              loading: false,
              plan: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }; 
  onChange = (e) => {
    this.GetPlansbyClientId(e, this.props.endata.plan_Id);
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className="mi_title" style={{ marginLeft: "8px" }}>
              {this.state.title}
              <br></br>
              <span className="mi_title2">
                Fill up the following form in order to new a Plan
              </span>
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col sm={24} md={8}>
              <fieldset className="mi_input_pop" style={{ marginRight: "2px" }}>
                <legend className="legend-font">Carrier</legend>
                {getFieldDecorator("carrier", {
                  rules: [{ required: true, message: "Please select carrier" }],
                })(
                  <Select
                    suffixIcon={
                      <Icon
                        style={{ transform: "rotate(90deg)" }}
                        type="double-right"
                      />
                    }
                    className="mi_input"
                    onChange={this.onChange}
                    defaultValue={this.state.id}
                    optionFilterProp="children"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Please Select Carrier"
                  >
                    {this.state.carrier
                      ? this.state.carrier.map((tag) => (
                        <Option value={tag.id} key={tag.id}>
                          {tag.name}
                        </Option>
                      ))
                      : ""}
                  </Select>
                )}
              </fieldset>
            </Col>
            <Col sm={24} md={8}>
              <fieldset className="mi_input_pop" style={{ marginRight: "2px" }}>
                <legend className="legend-font">Plan</legend>
                {getFieldDecorator("newPlan", {
                  rules: [{ required: true, message: "Please select Plan" }],
                })(
                  <Select
                    suffixIcon={
                      <Icon
                        style={{ transform: "rotate(90deg)" }}
                        type="double-right"
                      />
                    }
                    className="mi_input"
                    optionFilterProp="children"
                    showSearch={true}
                    defaultValue={this.state.name}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Please Select Plan"
                  >
                    {this.state.plan
                      ? this.state.plan.map((tag) => (
                        <Option value={tag.name} key={tag.name}>
                          {tag.name}
                        </Option>
                      ))
                      : ""}
                  </Select>
                )}
              </fieldset>
            </Col>
            <Col md={8} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Start Date</legend>
                  {this.props.endata.dis_enrolment_date
                    ? moment(this.props.endata.dis_enrolment_date)
                      .add(1, "days")
                      .format("MM/DD/yyyy")
                    : "none"}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: "30px" }}>
            <Col span={7}></Col>
            <Col span={5}>
              <Button
                className="mi_button_right submit-button"
                onClick={this.props.closeDrawerHandler}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img
                alt="example"
                style={{
                  height: "70px",
                  marginBottom: "-30px",
                  float: "right",
                }}
                src={img}
              />
            </Col>
            <Col span={7}></Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const ManagePlan = Form.create()(Plan);
export default ManagePlan;
